// extracted by mini-css-extract-plugin
module.exports = {"md":"gifts_md_164Un","ios":"gifts_ios_3zi-_","page":"gifts_page_13ABD","wrapper":"gifts_wrapper_2YT0m","subtitle":"gifts_subtitle_1S9P2","list":"gifts_list_2Q3GN"};